export default "__VITE_PUBLIC_ASSET__5638dc8f__"